<script setup lang="ts">
import { getWeek } from '/@src/utils/date'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { t } = useI18n()

//props
const props = defineProps({
  list: {
    type: Array
  },
  title: {
    type: String
  },
  edit: {
    type: Boolean
  },
  loading: {
    type: Boolean
  }
})

//emits
const emit = defineEmits<{
  (e: 'inputChange', e: any[], index: number): void
  (e: 'inputFouce', e: any[], index: number): void
  (e: 'removeTitle', item: any[], index: number): void
  (e: 'handleEditTitle', item: any[], index: number): void
}>()

//methods
const inputChange = (e, index) => {
  emit('inputChange',e,index)
}

const inputFouce = (e, index) => {
  emit('inputFouce',e,index)
}

const removeTitle = (item,index) => {
  emit('removeTitle',item,index)
}

const handleEditTitle = (item,index) => {
  emit('handleEditTitle',item,index)
}

//computed
const isShowList = computed(() => {
  if (props.list.find((x)=>x.content) || props.edit) {
    return false
  } else {
    return true
  }
})
</script>

<template>
  <div class="preview-list">
    <div class="title">
      <h4>{{ title }}</h4>
      <div class="date">GMT+8</div>
    </div>
    <VLoader v-if="!isShowList && list && list.length > 0">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="event-item"
      >
        <div class="event-time">{{ getWeek(item.date) }}</div>
        <input
          v-if="edit"
          :value="item.content?.title"
          type="text"
          class="input"
          :placeholder="t('editor-title-empty-placeholder')"
          @input="inputChange($event, index)"
          @focus="inputFouce($event, index)"
        />
        <div
          v-if="!edit"
          class="event-text"
          @click="handleEditTitle(item, index)"
        >
          {{ item.content ? item.content.title : '- - - -'}}
        </div>
        <div
          v-if="edit"
          class="delete-config"
          @click="removeTitle(item, index)"
        >
          <i class="iconify" data-icon="feather:trash-2"></i>
        </div>
      </div>
    </VLoader>
    <div class="placeholder" v-if="list?.length === 0 && !loading">
      <img src="https://rocks.wisburg.com/7b9cbb63-7e68-4e9d-ae40-6f3ad8e082fb.png" alt="">
      <p class="text">本周暂无重要事件</p>
    </div>
    <div v-if="loading">
      <div class="loading-update-item is-dark-bordered-12">
        <V-PlaceloadText
          :lines="5"
          width="75%"
          last-line-width="25%"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../../scss/abstracts/_mixins.scss';
.preview-list {
  width: 244px;
  margin: auto;
  .title {
    height: 32px;
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 16px;
    padding: 6px 8px;
    font-size: 14px;
    h4 {
      font-family: var(--font-alt);
      font-weight: 600;
      color: var(--white);
    }
    .date {
      color: var(--white);
      font-weight: 600;
    }
  }
  .event-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    .event-time {
      width: 10%;
      color: #a5a5a5;
      font-weight: 520;
    }
    .event-text {
      cursor: pointer;
      color: #000;
      padding-left: 10px;
      font-size: 14px;
      @include textLine(1);
    }
    .event-text:hover {
      font-weight: 600;
    }
    .input {
      height: 28px;
      margin-left: 15px;
      margin-right: 5px;
    }
    .delete-config {
      cursor: pointer;
      margin-right: -20px;
    }
  }
  .loading-update-item {
    .content-shape-group {
      .content-shape {
        margin: 40px 0px !important;
      }
    }
  }
  .placeholder {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    min-height: 280px;
    img {
      width: 112px;
    }
    p {
      color: #727272;
      font-size: 12px;
      margin-top: 12px;
    }
  }
}

.is-dark  {
  .preview-list {
    .event-text {
      color: var(--dark-text);
    } 
  }
}
</style>